<template>
  <!-- if no object/entity found fallback to error page -->
  <div v-if="err">
    <component :is="componentName" ref="error-page" />
  </div>
  <div v-else-if="indexedId">
    <router-view :id="indexedId" :key="indexedId" />
  </div>
</template>

<script>
import * as routerHelper from "@/helpers/routerHelper";
import { isJPC } from "@/helpers/configHelper";
import Error from "@/components/pages/error/index.vue";
import JPCAErrorPage from "@/components/pages/jpcaError/index.vue";

export default {
  name: "WithObjectPageLayout",
  components: { Error, JPCAErrorPage },

  data() {
    return {
      /**
       * The IndexedId for the record being loaded
       */
      indexedId: undefined,
      /**
       * The error from the router
       */
      err: undefined,
      /**
       * Any exceptions
       */
      exception: undefined,
      /**
       * Error page component name
       */
      componentName: isJPC() ? "JPCAErrorPage" : "Error"
    };
  },
  computed: {
    /**
     * Gets the page title from the social sharing tag to show, this should only happen if we don't have an ID,
     * which should only be on page load
     */
    title() {
      // this could be made better if we embedded the slug or id in the page and only show it if we have that info
      let title = document.querySelector('meta[name="og:title"]');
      if (title == undefined) {
        return "";
      }
      return title.content;
    }
  },
  watch: {
    "$route.params.slug": "getIndexedIdFromRoute"
  },
  created() {
    this.getIndexedIdFromRoute();
  },
  methods: {
    /**
     * Requests the Indexed ID from the ID Manager
     */
    getIndexedIdFromRoute() {
      // reset on page change
      this.indexedId = undefined;
      // request the indexedId from the route
      routerHelper.handle(this.$route).then((result) => {
        this.indexedId = result.indexedId;
        this.err = result.status;
        this.exception = result.exception;
      });
    }
  }
};
</script>

<style lang="scss">
.v-with-object-page-layout__status::before {
  content: "Loading... ";
}
</style>
